export default {
  headerHeight: 82,
};
